import {jsJsonPromise} from 'rlink-utils/json';
import checksumPath from 'rlink-router/checksumPath';
import contentChecksumPackagePathForLocale from 'rlink-router/contentChecksumPackagePathForLocale';

export default function loadChecksumsForLocale (locale, untranslatedChecksums, usingLongCaches, contentRoot) {
  if (!locale) {
    // all pages should have this included and loading right away
    return jsJsonPromise('content_checksums_base');
  } else {
    let localeChecksumPackagePath = contentChecksumPackagePathForLocale(locale);
    let localeChecksumPackageSrc;
    if (usingLongCaches) {
      let localeChecksumPackageChecksum = untranslatedChecksums[localeChecksumPackagePath];
      localeChecksumPackageSrc = `${contentRoot}${checksumPath(localeChecksumPackagePath, localeChecksumPackageChecksum)}`;
    } else {
      localeChecksumPackageSrc = `${contentRoot}${localeChecksumPackagePath}`;
    }

    let loadingScriptTag = document.querySelector(`script[src="${localeChecksumPackageSrc}"]`);
    if (!loadingScriptTag) {
      let script = document.createElement('script');
      script.src = localeChecksumPackageSrc;
      script.async = true;
      document.body.appendChild(script);
    }
    return jsJsonPromise(`content_checksums_${locale}`);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/loadChecksumsForLocale.js